import React from 'react';
import Logo from './Logo';
import LogoRetro from './LogoRetro';
import Auth from './Auth';
import {Link} from 'react-router-dom';
import { useSelector } from 'react-redux';

import './Header.css';

/* Natpis u zaglavlju stoji na dva mesta (u tekstu i u `data-tekst`), pa se drži
   na jednom mestu u kodu. */
const NAZIV = 'TMS';

const Header = props => {
  const planNovi = useSelector(state => state.planNovi || 0);
  const planNeprocitani = useSelector(state => state.planNeprocitani || 0);

  return (
    <header className="header">
      <div className="header-left">
        <button className="hamburger" onClick={props.onMenuToggle} aria-label="Meni">
          <span></span>
          <span></span>
          <span></span>
        </button>
        {/* Dva natpisa, a vidi se uvek samo jedan: retro tema ima svoj, crtan u
            SVG-u (vidi `LogoRetro.js` — zašto nije CSS). Prebacivanje ide kroz
            CSS, a ne kroz temu iz store-a, da se zaglavlje ne precrtava na svaku
            promenu teme i da natpis bude tačan već pri prvom iscrtavanju. */}
        <Link to="/pocetna">
          <p className="tpservis_header">{NAZIV}</p>
          <LogoRetro naziv={NAZIV} />
        </Link>
        {planNovi > 0 && (
          <span className="plan-novi-badge" title="Novi tiketi">{planNovi > 99 ? '99+' : planNovi}</span>
        )}
        {/* Odvojen od broja tiketa: ovaj kaze na koliko zadataka ceka
            nepročitan komentar. Dva razlicita podatka, pa i dva broja. */}
        {planNeprocitani > 0 && (
          <span className="plan-unread-badge" title="Zadaci sa nepročitanim komentarom">
            <i className="pi pi-comment" />{planNeprocitani > 99 ? '99+' : planNeprocitani}
          </span>
        )}
      </div>
      <Logo/>
      <div className="header-right">
        <Auth logout={props.logout} logged={props.token} user={props.user}/>
      </div>
    </header>
  );
};

export default Header;
